import { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  LabelList,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';
import axios from 'axios';
import i18next from 'i18next';
import { Loader } from '../';

const ChartEmbed = ({ stateSlug, totalSeats, height = 220 }) => {
  const [info, setInfo] = useState();
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchChart = async () => {
      try {
        const lang = localStorage.getItem('lang') || 'zh_CN';
        const res = await axios.get(`public-api/chart?state=${stateSlug}&lang=${lang}`);
        if (!cancelled) {
          setInfo(res.data || []);
          setDone(true);
        }
      } catch {
        if (!cancelled) setDone(true);
      }
    };
    fetchChart();
    return () => {
      cancelled = true;
    };
  }, [stateSlug, totalSeats]);

  if (!done) return <Loader inline />;
  if (!info || !info.length) return null;

  const majority = Math.floor(totalSeats / 2) + 1;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        layout="vertical"
        data={info}
        margin={{ top: 16, right: 24, left: 4, bottom: 4 }}
        barCategoryGap="18%"
      >
        <XAxis
          type="number"
          domain={[0, totalSeats]}
          tick={{ fontSize: 11, fill: '#666' }}
          axisLine={{ stroke: '#ddd' }}
          tickLine={false}
        />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 12, fill: '#333' }}
          width={70}
          axisLine={{ stroke: '#ddd' }}
          tickLine={false}
        />
        <ReferenceLine
          x={majority}
          stroke="#cb0c13"
          strokeDasharray="6 4"
          ifOverflow="visible"
          label={{
            value: `${majority} ${i18next.t('content')}`,
            position: 'top',
            fill: '#cb0c13',
            fontSize: 11,
          }}
        />
        <Bar
          dataKey="value"
          background={{ fill: '#eee', radius: 2 }}
          radius={[2, 2, 2, 2]}
          isAnimationActive={false}
        >
          {info.map((d, i) => (
            <Cell key={i} fill={d.colors} />
          ))}
          <LabelList
            dataKey="value"
            position="right"
            style={{ fill: '#1a1a1a', fontSize: 12, fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChartEmbed;
